/* global Isotope */

export default class IsotopeListing {
	constructor(gallery) {
		if ( ! gallery ) return;

		this.gallery = gallery;
		this.init();
	}

	init() {
		this.listingWrapperIsotope = new Isotope(
			document.querySelector( '.isotope-listing' ),
			{
				itemSelector: 'article',
			}
		);
	}
}
